import { useDispatch, useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import { handleProfileModal } from "../../action/index.js";
import { onSubmitLogout } from "../../action/manufacturers_auth/login.action.js";
import { logoutService } from "../../services/auth.service.js";

const AfterLogedIn = () => {
	const { const_var, discount_banner, params, isDealerDiscountBannerVisible } = useSelector((state) => state.reducer);
	const { redirectcrmflag, parentReducerData, targetRedirectUrl, resetpasswordcrm } = useSelector((state) => state.loginReducer);
	const dispatch = useDispatch();
	const userObj = JSON.parse(localStorage.getItem("userData") ?? "null") || "";
	const { showProfileModal, showDiscountBanner, stateManufacturerAcordingAPIDiscount, crmSetting } = const_var;
	const mfg_discount = stateManufacturerAcordingAPIDiscount?.["mfg_discount"];

	let checkOffer = false;
	if (discount_banner != true) {
		checkOffer = false;
	}
	if (mfg_discount != undefined) {
		if (mfg_discount[params.m_s_n] == undefined && crmSetting.companyType != "manufacturer") {
			checkOffer = true;
		}
		if (mfg_discount[params.m_s_n] != undefined && crmSetting.companyType == "manufacturer") {
			if (mfg_discount[params.m_s_n].length == 0 && !discount_banner) {
				checkOffer = true;
			}
		}
	}

	// Logout handler
	const handleLogout = async (e) => {
		try {
			await logoutService();
			dispatch(handleProfileModal(false));
			dispatch(onSubmitLogout(e));
		} catch (error) {}
	};

	// Overlay & menu style computation
	const isBannerCollapsed = localStorage.getItem("isBannerCollapsed");
	const showSetTopPosition = showDiscountBanner || (isBannerCollapsed != true && isDealerDiscountBannerVisible == true && (discount_banner || checkOffer));

	const overlayStyle = {
		transition: showProfileModal ? "all 0.01s ease" : "opacity 0.4s ease, transform 0.01s 0.4s ease",
		opacity: showProfileModal ? 1 : 0,
		transform: !showProfileModal ? "translate(100%, 0)" : undefined
	};

	const menuStyle = {
		opacity: showProfileModal ? 1 : 0,
		transform: showProfileModal ? "translate(0, 0)" : "translate(100%, 0)",
		height: window.innerWidth < 993 ? window.innerHeight : "auto"
	};

	return (
		<div show={showProfileModal} className="user-after-login">
			<div className="dropdown-toggle" onClick={() => dispatch(handleProfileModal(true))}>
				<span className="user-name" style={{opacity:1,width:'fit-content'}}>
					{userObj.first_name} {userObj.last_name}
				</span>
				<span className="icon-hamburger-ico"></span>
			</div>

			<div className="profile-dropdown-menu-overlay" style={overlayStyle}>
				<div className={showSetTopPosition ? "profile-dropdown-menu setTopPosition" : "profile-dropdown-menu"} style={menuStyle}>
					<div
						className="icon-close-container"
						onClick={(e) => {
							e.stopPropagation();
							dispatch(handleProfileModal(false));
						}}
					>
						<i className="icon-close"></i>
					</div>

					<div className="userprofile">
						<aside className="userprofile-right">
							<span>
								{userObj.first_name} {userObj.last_name}
							</span>
						</aside>
					</div>

					<Dropdown.Item target={redirectcrmflag == true ? "" : "_blank"} href={parentReducerData.navigation_url.lead}>
						<div>
							<span className="icon icon-lead-ico"></span>
						</div>
						<span className="text">Leads</span>
					</Dropdown.Item>

					<Dropdown.Item target={redirectcrmflag == true ? "" : "_blank"} href={parentReducerData.navigation_url.quote}>
						<div>
							<span className="icon icon-quote-ico"></span>
						</div>
						<span className="text">Quotes</span>
					</Dropdown.Item>

					{parentReducerData.navigation_url.my_account != undefined && (
						<Dropdown.Item target={redirectcrmflag == true ? "" : "_blank"} href={parentReducerData.navigation_url.my_account}>
							<div>
								<span className="icon icon-my-account-ico"></span>
							</div>
							<span className="text">My Account</span>
						</Dropdown.Item>
					)}

					{parentReducerData.navigation_url.my_team != undefined && (
						<Dropdown.Item target={redirectcrmflag == true ? "" : "_blank"} href={parentReducerData.navigation_url.my_team}>
							<div>
								<span className="icon icon-my-team-ico"></span>
							</div>
							<span className="text">My Team</span>
						</Dropdown.Item>
					)}

					{parentReducerData.navigation_url.my_subscription != undefined && (
						<Dropdown.Item target={redirectcrmflag == true ? "" : "_blank"} href={parentReducerData.navigation_url.my_subscription}>
							<div>
								<span className="icon icon-subscription-ico"></span>
							</div>
							<span className="text">My Subscription</span>
						</Dropdown.Item>
					)}

					{parentReducerData.is_CRM == true && (
						<Dropdown.Item
							target={redirectcrmflag == true ? "" : "_blank"}
							href={`${parentReducerData.web_url}/${parentReducerData.is_module_name}s/${targetRedirectUrl[parentReducerData.is_module_name].visualform}`}
						>
							<div>
								<span className="icon icon-classic-view"></span>
							</div>
							<span className="text">Text View</span>
						</Dropdown.Item>
					)}

					{parentReducerData.is_CRM == true && (
						<Dropdown.Item href={parentReducerData.web_url}>
							<div>
								<span className="icon-arrow-s2 icon"></span>
							</div>
							<span className="text">Back To CRM</span>
						</Dropdown.Item>
					)}

					{resetpasswordcrm == true && (
						<Dropdown.Item href="https://crm.senseicrm.com/update_password" target="_blank">
							<div>
								<span className="icon-reset-pass-ico icon"></span>
							</div>
							<span className="text">Reset Password</span>
						</Dropdown.Item>
					)}

					<Dropdown.Item className="logout-item" onClick={handleLogout}>
						<div>
							<span className="icon icon-logout-ico"></span>
						</div>
						<span className="text">Logout</span>
					</Dropdown.Item>
				</div>
			</div>
		</div>
	);
};
export default AfterLogedIn;
